import { CONFIG_FAHRZEUG_FORM } from './fahrzeug-form.config';
import { CONFIG_FAHRZEUG_FORM_LAYOUT } from './fahrzeug-form-layout.config';

export const CONFIG_FAHRZEUG_FORM_GLOBAL = {
  formConfig: CONFIG_FAHRZEUG_FORM,
  formValidationConfig: null,
  formLayoutConfig: CONFIG_FAHRZEUG_FORM_LAYOUT
};
